<template>
  <div id="modalDeleteUser" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Excluir Usuário</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="deleteUser">
          <div class="modal-body">
            Teme certeza que deseja excluir este usuário?
          </div>
          <div class="modal-footer border-top-0 pt-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              title="Excluir Usuário"
              :disabled="disableButton"
            >
              <span v-if="disableButton">
                <i class="ph ph-spinner spinner" />
              </span>
              <span v-else>Excluir</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { showModal, hideModal } from '@/utils/modal'

export default {
  name: 'DeleteUserModal',

  props: {
    userId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      disableButton: false,
    }
  },

  methods: {
    async deleteUser() {
      this.disableButton = true
      try {
        const response = await this.$store.dispatch('deleteUser', this.userId)

        hideModal()
        this.$emit('closeModal', true)
        this.$root.$refs.notification.success(response.message)
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    showModal('modalDeleteUser')
  },
}
</script>
